import { Clickable, Span, Strong } from '@ahmdigital/ui';
import styled from 'styled-components';

import { InnerWrapper } from '../styles';
import { useByocNavigationContext } from '../../../context/byoc-navigation-context';

const StyledStepName = styled(Span)`
  margin-left: 0.5rem;
`;

const StyledDiv = styled.div`
  position: relative;
`;

type Props = {
  isMobileNavExpanded: boolean;
  setIsMobileNavExpanded: (isExpanded: boolean) => void;
};

const MobileNavigation = ({ isMobileNavExpanded, setIsMobileNavExpanded }: Props) => {
  const { activeIndex, activeStep, steps } = useByocNavigationContext();
  const totalSteps = steps.length;
  const currentStep = activeIndex + 1;

  const handleStepsToggle = () => {
    setIsMobileNavExpanded(!isMobileNavExpanded);
  };

  const chevronName = isMobileNavExpanded ? 'app-chevron-up' : 'app-chevron-down';

  return (
    <StyledDiv>
      <InnerWrapper isMobile isMobileNavExpanded={isMobileNavExpanded}>
        <Clickable onClick={handleStepsToggle} isUnstyled icon={{ name: chevronName, position: 'right' }}>
          <Strong>
            Step {currentStep} of {totalSteps}:
          </Strong>
          <StyledStepName>{activeStep}</StyledStepName>
        </Clickable>
      </InnerWrapper>
    </StyledDiv>
  );
};

export default MobileNavigation;
